import React, { useEffect, useState } from 'react';
import HookForm from '../../../components/HookForm/HookForm';
import DealCreateEquipmentsModal from './DealCreateEquipmentsModal';
import { textStyles } from '../../../constants/textStyles';
import styles from './deal.module.css';
import formatNumber from '../../../utils/formatNumber';
import getDealCars from '../../../api/deals/getDealCars';
import Select from '../../../components/Select/Select';
import ButtonDelete from '../../../components/Button/ButtonDelete';
import removeItemsToDeal from '../../../api/deals/removeItemsToDeal';

const inputs = [];

const DealCreateEquipment = ({
  onSubmit,
  backHandler,
  deal,
  orders,
  equipments,
  update,
  setUnsavedEquipments,
  dealCars,
}) => {
  const [carsModal, setCarsModal] = useState(false);
  const openCarsModal = () => {
    setCarsModal(true);
  };

  const [cars, setCars] = useState([]);
  const onCarsFormSubmit = (equipments) => {
    equipments = equipments?.filter((item) => item?.n);
    setCarsModal(false);
    setCars([...cars, ...equipments]);
  };
  const [selectedOrder, setSelectedOrder] = useState(null);

  useEffect(() => {
    console.log('ORDER', orders);
    if (orders?.length > 0) {
      setSelectedOrder(orders[0]);
    }
  }, [orders]);
  useEffect(() => {
    setCars(equipments || []);
  }, [equipments]);

  const handleEquipmentDelete = (item) => {
    if (item?.n) {
      const newCars = cars.filter((car) => car.id !== item.id);
      console.log(newCars);
      setCars(newCars);
    } else {
      removeItemsToDeal({
        equipments: [{ value: item?.id }],
        dealId: deal?.id,
      }).then(() => {
        update();
      });
    }
  };

  useEffect(() => {
    setUnsavedEquipments(cars?.filter((item) => item?.n));
  }, [cars, setUnsavedEquipments]);

  return (
    <>
      {/* <p style={{ ...textStyles.formTitle, marginBottom: 20 }}>ÐÑÐ½Ð¾Ð²Ð½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ ÑÐ´ÐµÐ»ÐºÐµ</p> */}
      {/* {orders.length > 1 && (
        <div style={{ marginBottom: 20 }}>
          <Select title="ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ" onChange={setSelectedOrder} options={orders} value={selectedOrder} />
        </div>
      )} */}
      <HookForm
        inputs={inputs}
        title={'ÐÐºÑÐµÑÑÑÐ°ÑÑ'}
        grid={{ display: 'grid', gap: 20 }}
        onSubmit={() =>
          onSubmit(
            cars?.filter((item) => item?.n)?.map((item) => ({ value: item?.id, count: item?.n })),
            selectedOrder?.value
          )
        }
        action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
        customData={() => (
          <div style={{ display: 'grid', gap: 10 }}>
            {cars.map((item) => {
              return (
                <div
                  key={item.id}
                  style={{ display: 'grid', gridTemplateColumns: '1fr auto 50px', alignItems: 'center', gap: 10 }}
                >
                  <p style={textStyles.buttonText}>{item.title}</p>
                  <p>{item?.n || item?.count}</p>
                  <ButtonDelete onClick={() => handleEquipmentDelete(item)} />
                </div>
              );
            })}

            {cars?.length > 0 && (
              <>
                <hr style={{ border: '1px solid #D9D9D9', margin: '20px 0' }} />
                <p className={styles.stepsRow__value} style={{ ...textStyles.buttonText, color: '#05141F' }}>
                  {formatNumber(cars?.reduce((acc, car) => acc + car?.price * (car?.n || car?.count), 0))} KZT
                </p>
              </>
            )}
          </div>
        )}
        addCustomItemTitle="ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð°ÐºÑÐµÑÑÑÐ°ÑÑ"
        handleAddCustomItem={openCarsModal}
        backHandler={backHandler}
      />
      <DealCreateEquipmentsModal
        isOpen={carsModal}
        onRequestClose={() => setCarsModal(false)}
        onSubmit={(_, equipments) => {
          onCarsFormSubmit(Object.keys(equipments).map((key) => equipments[key]));
        }}
        onCancel={() => setCarsModal(false)}
        //TODO ÑÐ°ÑÐ´ÐºÐ¾Ð´ Ð¿Ð¾ÐºÐ° Ð½Ðµ Ð¿ÑÐ¾Ð´ÑÐ¼Ð°Ð½ Ð¸Ð½ÑÐµÑÑÐµÐ¹Ñ Ð´Ð»Ñ ÐºÐµÐ¹ÑÐ° Ñ Ð½ÐµÑÐºÐ¾Ð»ÑÐºÐ¸Ð¼Ð¸ Ð¼Ð°ÑÐ¸Ð½Ð°Ð¼Ð¸ Ð² ÑÐ´ÐµÐ»ÐºÐµ
        containerId={dealCars[0]?.container?.id}
        carId={dealCars[0]?.id}
        cityId={dealCars[0]?.cityId}
      />
    </>
  );
};

export default DealCreateEquipment;
